import { ROUTES } from 'constants/routes'
import { Icon } from 'gu-ui-kit'
import React from 'react'

const financeNavigationConfig = () => [
  {
    key: 'other',
    label_key: 'common::nav_menu.other',
    routes: [
      {
        exact: false,
        path: ROUTES.FINANCE_PAYMENT_PROFILES,
        key: 'finance/payment-profiles',
        label_key: 'user::navigation.payment-profiles',
        icon: <Icon name={'user'} size={'m'} />,
      },
      {
        exact: false,
        label_key: 'common::nav_menu.promised_payment_request',
        key: 'finance/promised_payment_request',
        path: ROUTES.FINANCE_PROMISED_PAYMENT_REQUEST,
        icon: <Icon name={'time-clock'} size={'m'} />,
      },
    ],
  },
]

export default financeNavigationConfig
